const getLatestDataObject = (dataObject) =>
  (Array.isArray(dataObject)
    ? [...dataObject]
    : Object.values(dataObject)
  ).sort((a, b) => b.Date - a.Date)?.[0] || null;

export default getLatestDataObject;
